var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6890: {
		fallback: () => (() => (__webpack_require__(8591))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	6058: {
		fallback: () => (() => (__webpack_require__(633))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	5244: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6467: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	7800: {
		fallback: () => (() => (__webpack_require__(7170))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	4137: {
		fallback: () => (() => (__webpack_require__(4518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	7223: {
		fallback: () => (__webpack_require__.e(648).then(() => (() => (__webpack_require__(3648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	9963: {
		fallback: () => (__webpack_require__.e(128).then(() => (() => (__webpack_require__(8128))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	9815: {
		fallback: () => (__webpack_require__.e(988).then(() => (() => (__webpack_require__(5988))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	3676: {
		fallback: () => (__webpack_require__.e(738).then(() => (() => (__webpack_require__(7738))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	5065: {
		fallback: () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(19))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	5233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	4014: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	6838: {
		fallback: () => (() => (__webpack_require__(1174))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "i18next",

	},
	8166: {
		fallback: () => (() => (__webpack_require__(7263))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "i18next-http-backend",

	},
	7418: {
		fallback: () => (() => (__webpack_require__(8386))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	7601: {
		fallback: () => (() => (__webpack_require__(4330))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "axios",

	},
	4084: {
		fallback: () => (() => (__webpack_require__(4435))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	8831: {
		fallback: () => (() => (__webpack_require__(1192))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zod",

	},
	3867: {
		fallback: () => (() => (__webpack_require__(2458))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-basket-store",

	},
	9775: {
		fallback: () => (() => (__webpack_require__(484))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-user-store",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [6890,6058,5244,6467,7800,4137,7223,9963,9815,3676,5065,5233,5244,6467,4014,4137,5233,6838,8166,7418,6058,7601,4084,8831];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"527": [
		6058,
		5244,
		6467,
		7800,
		4137,
		7223,
		9963,
		9815,
		3676,
		5065,
		5233
	],
	"594": [
		3867,
		9775
	],
	"636": [
		6838,
		8166,
		7418,
		6058,
		7601,
		4084
	],
	"792": [
		5244,
		6467,
		4014,
		4137,
		5233
	],
	"890": [
		6890
	],
	"998": [
		8831
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}